import { useEffect, useState } from 'react';
import { apiFetch } from '../../api/api';
import MediaTile from './MediaTile';
import UploadMediaPanel from './UploadMediaPanel';
import { toast } from 'react-toastify';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { getOrgMediaPath } from '../../utils/media/getOrgMediaPath';
import './tabs.css';
import './media.css';

const MediaLibraryPanel = ({
  organizationId,
  selectable = false,
  onSelect,
  onDelete,
}) => {

  const [media, setMedia] = useState(null);   // 🔥 null = not loaded yet
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const loadMedia = async () => {
    if (!organizationId) return;

    setLoading(true);

    try {
      const res = await apiFetch(
        `/media?organization=${organizationId}&type=image`
      );

      setMedia(res.items || []);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ load once per org
  useEffect(() => {
    if (!organizationId) return;
    if (media !== null) return;   // already cached

    loadMedia();

  }, [organizationId]);

  // ✅ upload → append instead of refetch
  const handleUploaded = async () => {
    try {
      const res = await apiFetch(
        `/media?organization=${organizationId}&type=image&limit=1&sort=desc`
      );

      const newest = res.items?.[0];

      if (newest) {
        setMedia(prev => [newest, ...prev]);
      }

    } catch {
      loadMedia(); // fallback
    }
  };

  const handleDelete = async (item) => {
    toast.info(
      <div>
        Delete this media?
        <div style={{ marginTop: 8 }}>
          <button
            onClick={async () => {
              try {

                await apiFetch(`/media/${item._id}`, { method: 'DELETE' });

                setMedia(prev => prev.filter(x => x._id !== item._id));

                onDelete?.(item);

                toast.dismiss();
                toast.success('Deleted');

              } catch (err) {
                toast.error(err.message);
              }
            }}
          >
            Yes
          </button>
        </div>
      </div>,
      { autoClose: false }
    );
  };

  return (
    <Tabs
      className="Tabs"
      selectedIndex={tabIndex}
      onSelect={setTabIndex}
    >

      <TabList>
        <Tab>Image Library</Tab>
        <Tab>Add Image</Tab>
      </TabList>

      <TabPanel>
        {loading || media === null ? (
          <div>Loading…</div>
        ) : (
          <div className="media-grid">
            {media.map(m => (
              <MediaTile
                key={m._id}
                media={m}
                src={getOrgMediaPath(m.s3Key)}
                selectable={selectable}
                onSelect={() => onSelect?.(m)}
                onDelete={handleDelete}
              />
            ))}
          </div>
        )}
      </TabPanel>

      <TabPanel>
        <div className="media-library">
          <UploadMediaPanel
            orgId={organizationId}
            onUploaded={handleUploaded}
          />
        </div>
      </TabPanel>

    </Tabs>
  );
};

export default MediaLibraryPanel;
